import {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import {IAM_SERVER_TENANT} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import Loading from "../../../utils/loading/Loading";



/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const TenantDetailModal = ({id, update}) => {

    const {closeModal} = useContext(ModalContext);
    const [isNull, setIsNull] = useState(false); //빈 값 확인
    const [loading, setLoading] = useState(true);
    const [businessNumberValid, setBusinessNumberValid] = useState(true);


    const [formData, setFormData] = useState({
        tenantId: '',
        tenantName: '',
        detail: '',
        businessName: '',
        businessNumber: '',
        createdBy: '',
        createdByName: '',
    });

    useEffect(() => {
        // id로 서비스 정보 조회
        const url = IAM_SERVER_TENANT + "/get/" + id;
        axios.get(url)
            .then((res) => {

                setFormData({
                    tenantId: res.data.data.tenantId,
                    tenantName: res.data.data.tenantName,
                    detail: res.data.data.detail,
                    businessName:res.data.data.businessName,
                    businessNumber:res.data.data.businessNumber,
                    createdByName:res.data.data.createdByName,
                    createdBy:res.data.data.createdBy
                });
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
                setLoading(false);
            })         
    }, []);

    const formatBusinessNumber = (numStr) => {
        if (!numStr || numStr.length !== 10) return numStr; // 이미 포맷된 값 또는 잘못된 길이
        return `${numStr.slice(0, 3)}-${numStr.slice(3, 5)}-${numStr.slice(5)}`;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "businessNumber") {
            // 숫자만 추출
            const numeric = value.replace(/[^0-9]/g, "").slice(0, 10);

            // 하이픈 포맷 적용: XXX-XX-XXXXX
            let formatted = numeric;
            if (numeric.length >= 6) {
            formatted = `${numeric.slice(0, 3)}-${numeric.slice(3, 5)}-${numeric.slice(5)}`;
            } else if (numeric.length >= 4) {
            formatted = `${numeric.slice(0, 3)}-${numeric.slice(3)}`;
            }

            setFormData((prev) => ({
            ...prev,
            [name]: formatted
            }));

            // 유효성 체크
            setBusinessNumberValid(numeric.length === 10);
        } else {
            setFormData((prev) => ({
            ...prev,
            [name]: value
            }));
        }
    };


    // 테넌트 등록 승인
    const handleApproval = () => {
        const url = IAM_SERVER_TENANT + "/update";
        const params = {
            tenantId: formData.tenantId,
            status: 'approval'
        };

        axios.post(url, params)
            .then((res) => {
            showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
            update();
            })
            .catch((e) => {
            showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    };

    // 테넌트 등록 거절
    const handleReject = () => {
        const url = IAM_SERVER_TENANT + "/update";
        const params = {
            tenantId: formData.tenantId,
            status: 'reject'
        };

        axios.post(url, params)
            .then((res) => {
            showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
            update();
            })
            .catch((e) => {
            showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }

    return (
        <div style={{overflow: "auto"}}>
            {loading ? <Loading/> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>
                                테넌트 명
                            </p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"tenantName"}
                                value={formData.tenantName}
                                readOnly={true}
                                onChange={handleChange}/>
                        </li>
                         <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>
                                소유주
                            </p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"createdByName"}
                                value={formData.createdByName}
                                readOnly={true}
                                onChange={handleChange}/>
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>사업자 명</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"businessName"}
                                readOnly={true}
                                value={formData.businessName}
                                onChange={handleChange}/>
                        </li>
                        <li className={styles.layer__list}>
                            <p lang={"ko"} className={styles.layer__listTit}>사업자 번호</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"businessNumber"}
                                readOnly={true}
                                value={formatBusinessNumber(formData.businessNumber)}
                                onChange={handleChange}/>
                        </li>
                    </ul>

                    <div className={styles.layer__sensorBtnBox}>
                        <button className={styles.layer__cancleBtn} onClick={handleReject}>거절</button>
                        <button className={styles.layer__modifyBtn} onClick={handleApproval}>승인</button>                        
                    </div>
                </div>
            }

        </div>
    );
}